<template>
  <el-container direction="vertical">
    <el-row>
      <el-col :span="5">
        <el-input v-model="pageData.filter" prefix-icon="el-icon-search" placeholder="输入设备名称查询" clearable @change="onSearch()" />
      </el-col>

      <el-col :span="2" class="col_pos_right" align="right">
        <el-button class="btn btn_1" @click="onSearch()">刷新</el-button>
      </el-col>
    </el-row>

    <el-container>
      <el-table :data="pageData.items" stripe border :height="$setTableHeight(1, 0)" :header-cell-style="{textAlign: 'center'}" :cell-style="{textAlign: 'center'}">
        <el-table-column v-for="it in tableColList" :key="it.key" :label="it.name" :fixed="it.fixed" :sortable="it.sortable" :sort-method="(a, b) => sortDateTime(a, b, it.key)">
          <template slot-scope="scope">
            <span>{{scope.row[it.key]}}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-container>

    <el-pagination
      background
      style="margin-top:14px"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pageData.total"
      :current-page="pageData.page"
      @current-change="onPageChange"
      :page-size="params.max_results"
      :page-sizes="$pageSizes"
      @size-change="onPageSizeChange"/>
  </el-container>
</template>

<script>
import Backend from '@/api/backend'
import Util from '@/api/util'

export default {
  data () {
    return Backend.initListPage(this, 'upgrade_task', {
      route_name: '升级记录列表',
      tableColList: [
        {
          key: 'last_modified_time',
          name: '操作时间',
          sortable: true
        },
        {
          key: 'user_name',
          name: '操作人'
        },
        {
          key: 'org_name',
          name: '客户'
        },
        {
          key: 'device_name',
          name: '设备名称'
        },
        {
          key: 'server_type_desp',
          name: '系统名称'
        },
        {
          key: 'version_manage_name',
          name: '版本号'
        },
        {
          key: 'upgrade_status_desp',
          name: '升级状态'
        },
        {
          key: 'upgrade_desc',
          name: '升级描述'
        }
      ]
    })
  },

  methods: {
    sortDateTime (a, b, key) {
      return Util.sortDateTime(a, b, key)
    },
    onSearch () {
      Backend.queryList(this, this.pageData.filter, 0)
    },
    onPageChange (v) {
      Backend.queryList(this, this.pageData.filter, v)
    },
    onPageSizeChange (v) {
      this.params.max_results = v
      Backend.queryList(this, this.pageData.filter, this.pageData.page === 0 ? 1 : this.pageData.page)
    }
  }
}
</script>
